import React from "react";
import FormInput from "../../../Components/Forms/FormInput/FormInput";

import { FormattedMessage, useIntl } from "react-intl";
import { createFormRequestHook, useFormState } from "../../../Components/Forms";
import {
  SideFormContent,
  SideFormFooter,
  SideForm,
} from "../../../Components/Forms/SideMenuForm";
import { spaceClientTypeSchema } from "../../../config/schema";
import { useClientType } from "../../../Hooks/EntityHooks";
import LoaderSpinner from "../../../Components/Loader/LoaderSpinner/LoaderSpinner";
import { useToast } from "../../../Components/Toast/ToastProvider";
import {
  BaseSidebarContainer,
  BaseSidebarHeader,
  useSidebarSpacePost,
  BaseSidebarContent,
  useSidebarSpaceDelete,
} from "../../../Components/Sidebar/SidebarV2Helper";
import { useHandleError } from "../../../Components/CGrid/ServerAwareHelper";

export const convertEntityToForm = (entity) => {
  //;
  const {
   Name
  } = entity;

  return {
   Name,
  };
};


const useClientTypeRequest = createFormRequestHook({
  schema: spaceClientTypeSchema,
  convertEntityToForm: convertEntityToForm,
});

const ClientTypeForm = ({ ...props }) => {
  const { id, onSuccess } = props;

  const {
    // key,
    loading,
    error,
    convertedForm,
    // isChild,
    // childProps,
  } = useClientTypeRequest(props);

  const cancel = useClientType(id);

  const canEdit = cancel ? cancel.CanEdit : true;

  const clientType = useClientType(id);

  if (loading || error)
    return <LoaderSpinner center size="sm" className="text-secondary" />;

  return (
    <Form
      onSuccess={onSuccess}
      id={id}
      canEdit={canEdit}
      convertedForm={convertedForm}
      canDelete={clientType?.CanDelete}
      {...props}
    />
  );
};








export const defaultForm = () => {
  return {
    Name: "",
  };
};

const Form = ({
  convertedForm,
  id,
  canEdit,
	onSuccess,
	refetchRef,
  isChild,
  canDelete,
  ...props
}) => {
  const formState = useFormState(() => {
    return {
      ...defaultForm(),
      ...convertedForm,
    };
  });
  const { form } = formState;
  const { Name } = form;

  const createToast = useToast();

  const handleTranslatedError = useHandleError(spaceClientTypeSchema);

  const intl = useIntl()
  const [post, { loading }] = useSidebarSpacePost(
    id ? `clienttypes/${id}` : `clienttypes`,
    spaceClientTypeSchema,
    {
      onSuccess: ({ openSidebar, data: newId, defineChildProps }) => {
        if (!id) defineChildProps({ ClientType: newId });
				createToast({
          pos: "tm",
          type: "success",
          title: `${intl.formatMessage({id: "ACCOUNT_TYPE"})} ${Name}`,
          description: intl.formatMessage({id: "SUCCESS_SAVED"}),
        });
        onSuccess && onSuccess();
			},
			refetchRef,
      onError: ({ error }) => {
        handleTranslatedError(error);
      },
    }
  );

  const [remove, { loading: deleteLoading }] = useSidebarSpaceDelete(
    `clienttypes/${id}`,
    spaceClientTypeSchema,
    {
      onSuccess: ({ openSidebar, data: newId, defineChildProps }) => {
        createToast({
          pos: "tm",
          type: "success",
          title: `${intl.formatMessage({id: "ACCOUNT_TYPE"})} ${Name}`,
          description: `${intl.formatMessage({ id: "SUCCESS_DELETED" })}`,
        });
      },
      onError: ({ error }) => {
        handleTranslatedError(error);
			},
			refetchRef
    }
  );

  const formatCancelForm = (form) => {
    const { Name } = form;
    return {
      Name,
    };
  };

  const handleSubmit = (form) => {
    post(formatCancelForm(form));
  };

  const validateCancelForm = ({ Name, DepartmentTeams }, addError) => {
    if (!Name) addError("Name");
  };

  return (
    <BaseSidebarContainer>
      <BaseSidebarHeader>
        <FormattedMessage id={"ACCOUNT_TYPE"} />
      </BaseSidebarHeader>
      <BaseSidebarContent>
        <SideForm
          canEdit={canEdit}
          formState={formState}
          onSubmit={handleSubmit}
          validate={validateCancelForm}
        >
          <SideFormContent className="px-4 py-3">
            <FormInput name="Name" textId="NAME" className="mb-3" />
          </SideFormContent>
          {/* <FormInput
          name="DepartmentTeams"
          className="mb-3"
          text={intl.formatMessage({ id: "department_team" })}
          inputType={DepartmentTeamDropdown}
          multiple
        /> */}

          {/* <FormInput
          name="Files"
          text={intl.formatMessage({ id: "files" })}
          inputType={FileUploader}
          className="mb-3"
        /> */}
          <SideFormFooter
            canDelete={canDelete}
            deleteLoading={deleteLoading}
            handleDelete={remove}
            isLoading={loading}
          />
        </SideForm>
      </BaseSidebarContent>
    </BaseSidebarContainer>
  );
};

// export default withSpaceEntityForm(withSpace(injectIntl(ClientTypeForm)), {
//   defaultForm: {
//     Name: ""
//   },
//   validateForm: ({ Name }, addError) => {
//     if (!Name) addError("Name");
//   },
//   convertEntityToForm: entity => {
//     const { Departments, Teams, ...rest } = entity;

//     const DepartmentTeams = convertToDepartmentTeams(entity);

//     return {
//       ...rest,
//       DepartmentTeams
//     };
//   },
//   formatForm: form => {
//     let { DepartmentTeams, Organizations, ...rest } = form;

//     return {
//       ...rest
//     };
//     // return createFormData(
//     //   {
//     //     ...rest,
//     //     organizations: Organizations.length === 0 ? undefined : Organizations,
//     //     departments: departments.length === 0 ? undefined : departments,
//     //     teams: teams.length === 0 ? undefined : teams
//     //   }
//     // );
//   },
//   schema: spaceClientTypeSchema
//   // getEntityId: (state, ownProps) => ownProps.interventionTypeId
// });
export default ClientTypeForm;
